export default "__VITE_ASSET__D9sNfGD0__"